var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon09ReserveStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "18px",
    viewBox: "0 0 16 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_\uD604\uD669") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "0_\\uC608\\uC57D\\uAD00\\uB9AC",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2-1-1_\\uC608\\uC57D\\uD604\\uD669_default",
    transform: "translate(-49.000000, -204.000000)",
    fill: "#46B476"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_\\uD604\\uD669",
    transform: "translate(57.000000, 213.000000) rotate(-270.000000) translate(-57.000000, -213.000000) translate(48.000000, 205.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.74193548,14.4637915 L2.74193548,10.5362085 C2.74193548,9.68785455 2.12814347,9 1.37096774,9 C0.613792015,9 0,9.68785455 0,10.5362085 L0,14.4637915 C0,15.3122285 0.613792015,16 1.37096774,16 C2.12814347,16 2.74193548,15.3122285 2.74193548,14.4637915 Z",
    id: "Fill-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.74193548,14.4816284 L7.74193548,1.51837156 C7.74193548,0.679785753 7.12814347,0 6.37096774,0 C5.61379201,0 5,0.679785753 5,1.51837156 L5,14.4816284 C5,15.3202142 5.61379201,16 6.37096774,16 C7.12814347,16 7.74193548,15.3202142 7.74193548,14.4816284 Z",
    id: "Fill-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7419355,13.0712945 L12.7419355,1.3705007 C12.7419355,0.613582916 12.1281435,0 11.3709677,0 C10.613792,0 10,0.613582916 10,1.3705007 L10,13.0712945 C10,13.8282123 10.613792,14.4417952 11.3709677,14.4417952 C12.1281435,14.4417952 12.7419355,13.8282123 12.7419355,13.0712945 Z",
    id: "Fill-6-Copy"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7419355,14.4816284 L12.7419355,1.51837156 C12.7419355,0.679785753 12.1281435,0 11.3709677,0 C10.613792,0 10,0.679785753 10,1.51837156 L10,14.4816284 C10,15.3202142 10.613792,16 11.3709677,16 C12.1281435,16 12.7419355,15.3202142 12.7419355,14.4816284 Z",
    id: "Fill-6-Copy"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7419355,14.4816284 L17.7419355,1.51837156 C17.7419355,0.679785753 17.1281435,0 16.3709677,0 C15.613792,0 15,0.679785753 15,1.51837156 L15,14.4816284 C15,15.3202142 15.613792,16 16.3709677,16 C17.1281435,16 17.7419355,15.3202142 17.7419355,14.4816284 Z",
    id: "Fill-6-Copy-2"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon09ReserveStatus);
export default __webpack_public_path__ + "static/media/icon09_reserveStatus.69cc08e7193b565e4bc4b7024194f833.svg";
export { ForwardRef as ReactComponent };